import {$dom} from '../../helpers/dom';
import variables from '../../variables';
import {$events} from '../../helpers/events';
import {isElement} from '../../helpers/_utilities';
import gsap from 'gsap';

const {
	exist,
	get
} = $dom;

const {
	searchForm
} = variables.selectors;

export default function articleSearch(
	inputSelector = '.js-search-form-input',
	notifyAreaSelector = '.js-search-form-notify',
	resetButtonSelector = '.js-search-form-reset',
	selectSelector = '.js-search-form-select',
	sortValueOutputSelector = '.js-search-form-sort-value'
) {

	if (exist([
		searchForm,
		inputSelector,
		notifyAreaSelector,
		resetButtonSelector])) {

		let field;


		const
			inputMinLength = 3,
			inputDelay = 500,
			debounce = (callback, delay = inputDelay) => {
				let timeout;
				return function executedFunction(...args) {
					const later = () => {
						clearTimeout(timeout);
						callback(...args);
					};
					clearTimeout(timeout);
					timeout = setTimeout(later, delay);
				};
			},
			checkSuggestion = () => {
				let fieldIsEmpty = field.value === '' || field.value.length < inputMinLength;

				gsap.to(notifyAreaSelector, {
					autoAlpha: fieldIsEmpty ? 0 : 1,
					duration: variables.gsapDefaultDuration / 2
				});

				$dom[fieldIsEmpty ? 'removeClass' : 'addClass'](searchForm, 'have-suggestions')
			},
			validateInput = debounce(({target}) => {
				if (target.value.length >= inputMinLength) {
					$events.emit(variables.customEventNames.articleSearchDone, window, {
						value: target.value
					});
				}else{
					checkSuggestion();
				}
			}),
			resetValue = () => {
				field.value = '';
				checkSuggestion();
			},
			emitSubmitFromSelect = (e) => {
				get(sortValueOutputSelector).value = e.detail.choice.value;
				get(searchForm).submit()
			},
			init = () => {
				if (!isElement(field)) field = get(inputSelector);
				checkSuggestion();

				$events.delegate
					.on('input', inputSelector, validateInput)
					.on('click tap', resetButtonSelector, resetValue)
					.on('choice', selectSelector, emitSubmitFromSelect)
			},
			destroy = () => {
				$events.delegate
					.off('input', inputSelector, validateInput)
					.off('click tap', resetButtonSelector, resetValue)
					.off('choice', selectSelector, emitSubmitFromSelect)
			}
		;

		return {init, destroy, checkSuggestion}
	}
	return null
}
